import classNames from 'classnames'
import React from 'react'
import {Animated} from '../../../../../../../commons/components/animated'
import {FullDateLocation} from '../../../full-date-location'
import {Ribbon} from '../../../ribbon'
import {RsvpButton} from '../../../rsvp-button'
import {Date} from '../../common/date'
import {Description} from '../../common/description'
import {Image} from '../../common/image'
import {Members} from '../../common/members'
import {Share} from '../../common/share'
import {Title} from '../../common/title'
import {useWidgetState} from '../../../../hooks/state-provider'
import {isItemOpened} from '../../../../selectors/layout'
import {
  isAdditionalComponentsHidden,
  isDescriptionVisible,
  isFullDateVisible,
  isImageVisible,
  isLocationVisible,
  isMembersVisible,
  isSquareImage,
} from '../../../../selectors/list-settings'
import {getComponentConfig, isListLayout} from '../../../../selectors/settings'
import {getRibbonData} from '../../../../selectors/events'
import {isSite} from '../../../../../../../commons/selectors/environment'
import {AdditionalInfoToggle} from '../../common/additional-info-toggle'
import s from './cards-mobile-item.scss'

export const CardsMobileItem = ({event, hovered}: {event: ExtendedEvent; hovered: boolean}) => {
  const opened = useWidgetState(state => isItemOpened(state, event.id))
  const showImage = useWidgetState(isImageVisible)
  const showMembers = useWidgetState(state => isMembersVisible(state, event))
  const listLayout = useWidgetState(state => isListLayout(getComponentConfig(state)))
  const squareImage = useWidgetState(state => isSquareImage(state, true))
  const listShowFullDate = useWidgetState(isFullDateVisible)
  const listShowLocation = useWidgetState(isLocationVisible)
  const listShowDescription = useWidgetState(isDescriptionVisible)
  const additionalComponentsHidden = useWidgetState(isAdditionalComponentsHidden)
  const showRibbon = useWidgetState(state => getRibbonData(state, event).visible)
  const animates = useWidgetState(isSite)

  return (
    <>
      {showImage && (
        <div className={classNames(s.imageDate, {[s.imageOverlay]: showImage})}>
          <Image event={event} squareImage={squareImage} />
        </div>
      )}
      {showRibbon ? <Ribbon event={event} className={s.ribbon} /> : null}
      <Date event={event} />
      <Title event={event} />
      {additionalComponentsHidden ? null : (
        <AdditionalInfoToggle
          active={!additionalComponentsHidden && (hovered || opened)}
          opened={opened}
          listLayout={listLayout}
        />
      )}
      <Animated disabled={!animates} show={opened && !additionalComponentsHidden} height={calculateContentHeight}>
        <div className={classNames(s.content, listLayout ? s.listContentText : s.mobileCardsContentText)}>
          <FullDateLocation event={event} showDate={listShowFullDate} showLocation={listShowLocation} />
          <Members event={event} visible={showMembers} />
          <Description event={event} visible={listShowDescription} />
          <Share event={event} />
        </div>
      </Animated>
      <div style={{marginTop: opened ? 24 : 30, width: '100%'}}>
        <RsvpButton event={event} fullWidth />
      </div>
    </>
  )
}

const calculateContentHeight = (element: HTMLElement) => element.offsetHeight + 60
